<template>
    <section class="quick-link quick-link-style1 parallax mg-bottom30">
        <div class="container" style="">
            <div class="row course-package-card">
                <div class="col-lg-7" style="padding-left: 30px;">
                    <div class="wrap-link-left">
                        <div class="caption lt-sp275">
                            Purchase as part of a package and save
                        </div>
                        <div class="heading-lf lt-sp03">
                            {{ coursePackage.name }}
                        </div>
                        <p>
                            {{ coursePackage.descriptionShort }}
                        </p>
                        <div class="price" style="margin-top: 20px">
                            <span class="price-now">R {{ coursePackage.price }}</span>
                            <span class="price-old"><del>R {{ totalValue }}</del></span>
                        </div>
                        <div v-if="totalValueUsd" class="price" style="margin-top: 20px">
                            <span class="price-now">$ {{ coursePackage.priceUsd }}</span>
                            <span class="price-old"><del>$ {{ totalValueUsd }}</del></span>
                        </div>
                        <div class="btn-apply-link">
                            <ul>
                                <li>
                                    <button v-on:click="addToCart" class="btn btn-apply bg-clff5f60">Add to cart</button>
                                </li>
                                <!--
            <li>
                <a class="btn btn-request lt-sp06">More details</a>
            </li>
                -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5" style="padding-right: 30px;">
                    <div class="wrap-link-right">
                        <div class="heading-rg">
                            <span>Included Courses</span>
                        </div>
                        <ul class="info-quick-link">
                            <li v-for="course in coursePackage.courses">
                                <img :src="course | s3url" style="width: 29px; height: 31px" alt="images">
                                <router-link :to="{ name: 'CourseInfo', params: { id: course.id }}">{{ course.name }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>

    .quick-link {
        position: inherit;
        padding-bottom: 0px;
        padding-top: 50px;
    }

    .heading-lf {
        color: white;
    }

    .caption {
        color: #ff9933;
    }

    .btn-apply-link {
        margin-top: 20px;
    }

    .bg-clff5f60 {
        background-color: white;
        color: #3d3c79 !important;
    }

    .course-package-card {
        background-image: url('/wwwroot/images/header/lightning-4.jpg');
        background-color: rgb(63, 76, 153, 0.8);
        background-blend-mode: multiply;
        background-position: center;
        background-size: cover;
        padding-top: 30px !important;
        padding-bottom: 30px !important;
        margin-left: -18px;
        margin-right: -18px;
    }

    .price-now {
        font-size: 28px;
        color: #ff9933;
        margin-right: 10px;
        font-weight: bold;
    }

    .price-old {
        font-size: 24px;
        color: white;
    }
</style>
<script>
    export default {
        name: 'CoursePackageComponent',
        props: {
            coursePackage: Object,
        },
        methods: {
            addToCart() {
                this.$store.commit("addToCart", {
                    type: "package",
                    id: this.coursePackage.id,
                    name: this.coursePackage.name,
                    price: this.coursePackage.price,
                    priceUsd: this.coursePackage.priceUsd,
                    imageFileName: this.coursePackage.imageFileName
                });
            }
        },
        computed: {
            totalValue() {
                var total = this.coursePackage.courses.reduce((total, course) => total + course.price, 0);
                return total;
            },
            totalValueUsd() {
                var total = this.coursePackage.courses.reduce((total, course) => total + course.priceUsd, 0);

                if (total == undefined || isNaN(total) || total == null)
                    return null;

                return total;
            },
        }
    }
</script>

<style scoped>
</style>